import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { FieldTypes } from "app/shared/model/enums";

@Component({
  selector: 'app-coupon-card-mobile',
  templateUrl: './coupon-card-mobile.component.html',
  styleUrl: './coupon-card-mobile.component.scss'
})
export class CouponCardMobileComponent {
  @Input()
  currentCoupon
  @Input()
  columns
  @Output()
  resend = new EventEmitter<string>();
   fieldTypes = FieldTypes;
  constructor(private localizationService:LocalizationService ) { }

  ngOnInit(): void {
  
  }
  getLinkText(field: string, value: string): string {
  const fieldTranslationMap: { [key: string]: string } = {
    rouletteLink: "BUSINESS_COUPON.ROULETTE_LINK",
    link: "BUSINESS_COUPON.COUPON_LINK"
  };

  if ((field in fieldTranslationMap) && value) {
    return this.localizationService.Translate(fieldTranslationMap[field]);
  }
  return value;
}
}
